<template>
	<div style="padding: 20px" class="final-report agency-final-report">

		<div v-if="metadata.status === 'NEW' && metadata.status === 'REQUESTED_CHANGES'" class="d-none print-only"><h1>
			Wydruk próbny !</h1></div>

		<v-layout justify-end mr-3 class="no-print">
			<v-btn @click="print">Wydrukuj</v-btn>
		</v-layout>

		<agency-final-report-header
			:project-title="readOnlyData.projectTitle"
			:project-code="readOnlyData.projectCode"
			:control-sum="readOnlyData.controlSum"
			:agency-name="readOnlyData.agencyName"
			:partner-name="filledData.partnerName"
			:project-start-date="filledData.projectStartDate"
			:project-end-date="filledData.projectEndDate"
			:minister-donation="readOnlyData.ministerDonation"
			:approved-donation="readOnlyData.approvedDonation"
			:send-date="sendDate"
			:approval-date="approvalDate"
			:currency="readOnlyData.currencyCode"
			:show-approved-header="metadata.status === 'APPROVED'"/>

		<v-divider class="ma-4"/>

		<div class="mt-3 mb-3" style="page-break-inside: avoid" v-if="configuration.form">
			<h2 style="margin-left: 20px">{{ configuration.form.sections[0].name }} </h2>
			<vue-form-generator
				:disabled="true"
				name="generator"
				ref="vfg"
				:model="reportData.model"
				:options="formGenerator.formOptions"
				:schema="formGenerator.currentSchema"
				v-if="viewData.showGenerator">
			</vue-form-generator>
		</div>

		<v-divider class="ma-4"/>

		<div style="page-break-inside: avoid">
			<h3 class="mt-4 mb-4 ml-4">Sprawozdanie finansowe</h3>

			<v-layout row wrap>
				<v-flex d-flex xs12>
					<v-card color="grey darken-1">
						<v-card-text class="financial-table-header-font-size financial-table-header-dark-color">
							<v-layout>
								<strong>
									SPRAWOZDANIE FINANSOWE Z REALIZACJI PROJEKTU {{readOnlyData.projectCode}}
								</strong>
							</v-layout>
							<v-layout>

								<strong>
									<v-flex>Kwota przyznana z MSZ: {{ formatMoney(readOnlyData.totalMSZFunding) + " " +
										readOnlyData.currencyCode }}
									</v-flex>
									<v-flex>Środki ogółem: {{ formatMoney(readOnlyData.totalFunding) + " " +
										readOnlyData.currencyCode }}
									</v-flex>

								</strong>
							</v-layout>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
		</div>


		<v-layout row wrap style="page-break-inside: avoid"
			class="financial-table-header-font-size financial-table-header-color">
			<v-flex d-flex xs3>
				<v-card color="grey darken-0">
					<v-card-text>
						<strong>
							Rodzaj płatności
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs4>
				<v-card color="grey darken-0">
					<v-card-text>
						<strong>
							Opis wydatków
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs3>
				<v-card color="grey darken-0">
					<v-card-text>
						<strong>
							Data płatności
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs2>
				<v-card color="grey darken-0">
					<v-card-text>
						<strong>
							Kwota ({{ readOnlyData.currencyCode }})
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>

		<v-form ref="form" class="financial-table-header-font-size">
			<v-layout row wrap v-for="(cost,index) in filledData.costs" :key="index" style="page-break-inside: avoid">
				<v-flex d-flex xs3>
					<v-card color="grey lighten-1">
						<v-card-text style="padding: 7px">
							<div>
								{{cost.costType}}
							</div>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs4>
					<v-card color="grey lighten-1">
						<v-card-text style="padding: 7px">
							<div>
								{{cost.description}}
							</div>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs3>
					<v-card color="grey lighten-1">
						<v-card-text style="padding: 5px">
							<egranty-date-picker
								:disabled="true"
								:required="true"
								label="Data płatności"
								v-model="cost.paymentDate"
							/>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs2>
					<v-card color="grey lighten-1">
						<v-card-text style="padding: 5px">
							<egranty-number-input-field
								:disabled="true"
								:label="'Kwota (' + readOnlyData.currencyCode + ')'"
								v-model="cost.value"
								:suffix="readOnlyData.currencyCode"
							/>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
		</v-form>
		<v-form ref="form2" v-if="filledData.costs" class="financial-table-header-font-size">
			<v-layout row wrap style="page-break-inside: avoid">
				<v-flex d-flex xs10>
					<v-card color="grey darken-0" class="financial-table-header-color">
						<v-card-text>
							<strong>
								Ogółem
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs2>
					<v-card color="grey lighten-1">
						<v-card-text style="padding-right: 10px; padding-left: 10px; text-align: right">
							<strong>
								{{formatMoney(filledData.costs.map(cost => parseToFloat(cost.value)).reduce((a, b) => a
									+ b, 0))}} {{readOnlyData.currencyCode}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
		</v-form>

		<div class="ma-5 signature signature-header-font-size">
			<v-layout row>
				<table style="width:100%; border: 1px solid black; border-collapse: collapse">
					<tr style="height: 35px; border: 1px solid black">
						<th class="ma-2"
							style="padding: 5px; width: 50%; text-align: center; border: 1px solid black">
							Podpis pracownika placówki wyznaczonego do realizacji projektu
						</th>
						<th style="padding: 5px; width: 50%; text-align: center; border: 1px solid black">
							Podpis kierownika placówki lub osoby pełniącej funkcję zastępcy kierownika placówki
						</th>
					</tr>
					<tr style="height: 60px">
						<td style="border: 1px solid black"></td>
						<td style="border: 1px solid black"></td>
					</tr>
				</table>

			</v-layout>
		</div>

		<agency-project-final-report-confirmation-dialog
			:action="send"
			:dialog-model="viewData.sendReportDialog"
			@close-confirmation="viewData.sendReportDialog = false"
			:loading="loading"
		/>

		<egranty-validation-error
			:error="error"
		/>

		<div v-if="metadata.status === 'NEW' && metadata.status === 'REQUESTED_CHANGES'" class="d-none print-only"><h1>
			Wydruk próbny !</h1></div>
	</div>
</template>

<script>
	import {genericFormUtil} from "@/utils/genericFormUtil";
	import {AgencyFinalReport} from "@/api/generated/AgencyFinalReport";
	import AgencyProjectFinalReportConfirmationDialog from "./components/AgencyProjectFinalReportConfirmationDialog";
	import EgrantyDatePicker from "../../../genericComponents/EgrantyDatePicker";
	import EgrantyNumberInputField from "../../../genericComponents/EgrantyNumberInputField";
	import EgrantyValidationError from "../../../genericComponents/EgrantyValidationError";
	import {Numbers} from "@/utils/Numbers";
	import AgencyFinalReportHeader from "./components/AgencyFinalReportHeader";
	import {Files} from "@/utils/Files";

	export default {
		name: "AgencyProjectFinalReportReadOnlyView",
		components: {
			AgencyFinalReportHeader,
			EgrantyValidationError,
			EgrantyDatePicker,
			AgencyProjectFinalReportConfirmationDialog,
			EgrantyNumberInputField,
		},
		mixins: [Numbers],
		watch: {
			"reportData.model": {
				handler () {
					this.applyGenericForm(this.configuration.form);
				},
				deep: true,
			},
		},

		data () {
			return {
				error: "",
				metadata: {},

				configuration: {
					form: "",
				},

				reportData: {
					model: undefined,
				},

				viewData: {
					sendReportDialog: false,
				},

				projectId: this.$route.params.projectId,

				agencyContestId: this.$route.params.id,

				filledData: {},

				readOnlyData: {},

				sendDate: '',

				approvalDate: '',

				readOnly: true,

				formGenerator: {
					currentSchema: {},
					currentModel: {},
					formOptions: {
						validateAfterLoad: false,
						validateAfterChanged: true,
						validateAsync: true,
					},
					currentConditionalHashes: [],
				},
				loading: false,
			};
		},

		created () {
			this.loadData();
		},

		methods: {

			validate () {
				this.error = "";
				if (!this.filledData.projectStartDate) {
					this.error = "Proszę uzupełnić datę początku projektu";
				}
				if (!this.filledData.projectEndDate) {
					this.error = "Proszę uzupełnić datę końca projektu";
				}
				if (!this.filledData.partnerName) {
					this.error = "Proszę uzupełnić nazwę partnera";
				}

				return this.error === "";
			},

			emptyCost () {
				return {
					costType: "",
					description: "",
					paymentDate: null,
					value: null,
				};
			},

			async loadData () {

				AgencyFinalReport.getConfiguration(this, this.agencyContestId, this.loadConfigurationAndFilledData);

				AgencyFinalReport.getReadOnlyData(this, this.projectId, (response) => this.readOnlyData = response);

				AgencyFinalReport.getCurrentState(this, this.projectId, (response) => this.metadata = response);

				AgencyFinalReport.getSendAndApprovalDates(this, this.projectId, success => {
					this.sendDate = success.sendDate;
					this.approvalDate = success.approvalDate;
				});
			},

			loadConfigurationAndFilledData (configuration) {
				this.configuration.form = genericFormUtil.decodeSchema(configuration.schema);

        if (!this.configuration.form) {
          this.$messagesBus.$emit("error", "Niezdefiniowany formularz generyczny");
          return;
        }

				this.formGenerator.currentSchema = genericFormUtil.getSectionSchemaFromSchema(this.configuration.form, 0, this.configuration.disabled);

				AgencyFinalReport.getFilledData(this, this.projectId, success => {
					this.filledData = success;
					if (success.filledForm === null) {
						this.reportData.model = genericFormUtil.buildModelFromSchema(this.configuration.form).sections[0].fields;
					} else {
						this.reportData.model = genericFormUtil.decodeSchema(success.filledForm);
					}
					this.applyGenericForm(this.configuration.form);
					this.viewData.showGenerator = true;
				});
			},

			saveReport () {
				AgencyFinalReport.postData(this, this.projectId, this.filledData, successResponse => {
					this.$messagesBus.$emit("success", "Pomyślnie zapisano raport", successResponse);
				}, errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się zapisać raportu", errorResponse);
				});
			},

			async send () {
				if(!this.loading){
					this.loading = true;
				let validationPromise = await this.$refs.vfg.validate();
				if (validationPromise.length > 0) {
					this.$messagesBus.$emit("error", "Uzupełnij poprawnie dane!");
					this.viewData.sendReportDialog = false;
					this.loading = false;
					return;
				}
				this.$validator.validateAll().then((result) => {
					if (result) {
						if (!this.$refs.form.validate() || !this.validate()) {
							this.$messagesBus.$emit("error", "Uzupełnij poprawnie dane!");
							this.viewData.sendReportDialog = false;
							this.loading = false;
							return;
						}
						AgencyFinalReport.postSaveAndSubmit(this,
							this.projectId,
							this.filledData,
							successResponse => {
								this.$messagesBus.$emit("success", "Raport został wysłany!", successResponse);
								this.loadData();
							}, errorResponse => {
								this.$messagesBus.$emit("error", "Nie udało się wysłać raportu", errorResponse);
							});
						this.viewData.sendReportDialog = false;
						this.loading = false;
					} else {
						this.$messagesBus.$emit("error", "Uzupełnij poprawnie dane!");
						this.viewData.sendReportDialog = false;
						this.loading = false;
					}
				});
			}
			},

			applyGenericForm (form) {
				this.filledData.filledForm = genericFormUtil.encodeSchema(this.reportData.model);

        if (!form) {
          this.$messagesBus.$emit("error", "Niezdefiniowany formularz generyczny");
          return;
        }

				let schema = genericFormUtil.getSectionSchemaFromSchema(form, 0, true);
				if (genericFormUtil.sectionSchemaContainsConditionalField(schema)) {
					let schemaValues = this.reportData.model;
					this.formGenerator.currentSchema = genericFormUtil.filterSchemaByConditionalFieldsValue(schema, schemaValues);
					let indexes = genericFormUtil.calculateIndexes(schema);
					this.formGenerator.currentConditionalHashes = genericFormUtil.getConditionalValueHashes(schema, indexes);
				} else {
					this.formGenerator.currentSchema = schema;
				}
			},

			async print () {
				await Files.methods.downloadFileAsBlob(
					this,
					Files.methods.getAgencyProjectFinalReportPrintUrl(
						this.agencyContestId,
						this.projectId
					),
					"sprawozdanie_końcowe.pdf"
				);
			}
		}
	};
</script>

<style scoped>
	.signature-header-font-size * {
		font-size: 14px;
	}

	@media print {
		.signature-header-font-size * {
			font-size: 11px;
		}
	}
</style>
